import { render } from "./FieldPhone.vue?vue&type=template&id=c85f6462"
import script from "./FieldPhone.vue?vue&type=script&lang=js"
export * from "./FieldPhone.vue?vue&type=script&lang=js"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon});
